import { __assign } from "tslib";
import * as React from 'react';
import s from './collection.scss';
import { CollectionHeader, dtoToCollectionHeaderProps, } from '../collection-header';
import { CollectionDescription } from '../collection-description';
import { SolutionGridWrapper, } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { FluidContainer } from '../../FluidContainer';
import { Box, Text } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
import { getCollectionDefinition, } from '@wix/app-market-collection-widget';
export var dtoToCollectionProps = function (res) {
    var _a, _b, _c, _d, _e, _f;
    var headerProps = dtoToCollectionHeaderProps(res);
    var description = ((_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.tagsAndSubCategories) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.tag) === null || _c === void 0 ? void 0 : _c.description) || '';
    var appsCount = res.webSolutions.length;
    var solutionGridWrapperProps = {
        solutions: res.webSolutions.map(function (solution, appIndex) {
            return __assign({ appIndex: appIndex }, solution.baseInfo);
        }),
        isCompany: true,
        referralSectionName: getCollectionDefinition(res.tagsAndSubCategories[0].tag).slug,
        hideTagsBadge: ((_f = (_e = (_d = res === null || res === void 0 ? void 0 : res.tagsAndSubCategories) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.tag) === null || _f === void 0 ? void 0 : _f.slug) === 'black-friday-sale',
    };
    return {
        headerProps: headerProps,
        description: description,
        appsCount: appsCount,
        solutionGridWrapperProps: solutionGridWrapperProps,
    };
};
export var Collection = composer()
    .withTranslation()
    .compose(function (_a) {
    var headerProps = _a.headerProps, description = _a.description, appsCount = _a.appsCount, solutionGridWrapperProps = _a.solutionGridWrapperProps, t = _a.t;
    return (React.createElement("div", { "data-testid": 'collection' },
        React.createElement(FluidContainer, { className: s.newHeaderWrapper },
            React.createElement(CollectionHeader, __assign({}, headerProps)),
            React.createElement(CollectionDescription, { description: description, wordsLimit: 70 }),
            React.createElement(Box, { marginTop: '24px', marginBottom: '3px', className: s.mobileHeaderSpacing },
                React.createElement(Text, { className: s.appsCount, tagName: "h2", secondary: true },
                    t('collection.apps-counter', { appsCount: appsCount }),
                    ' ')),
            React.createElement(SolutionGridWrapper, __assign({}, solutionGridWrapperProps)))));
});
//# sourceMappingURL=collection.js.map